import { Flex, Divider, Text, HStack } from '@chakra-ui/react'

type Props = {
  text?: string
  children: JSX.Element
}

export default function CustomFormBuilderConfigsLayout({ text = 'Configurações', children }: Props) {
  return (
    <Flex flexDir="column" gap={4}>
      <HStack>
        <Divider />
        <Text textStyle="md" fontWeight="medium" whiteSpace="nowrap">
          {text}
        </Text>
        <Divider />
      </HStack>

      {children}
    </Flex>
  )
}
